var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.507,
    height: 15.948,
    viewBox: "0 0 13.507 15.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_37137",
    "data-name": "Gruppe 37137",
    transform: "translate(0.65 0.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_akar-copy",
    "data-name": "Icon akar-copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47113",
    "data-name": "Pfad 47113",
    d: "M12,4.465v8.789a1.465,1.465,0,0,0,1.465,1.465h5.859a1.465,1.465,0,0,0,1.465-1.465V6.839a1.465,1.465,0,0,0-.441-1.047L17.92,3.417A1.465,1.465,0,0,0,16.9,3H13.465A1.465,1.465,0,0,0,12,4.465Z",
    transform: "translate(-8.582 -3)",
    fill: "none",
    stroke: "#44554c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47114",
    "data-name": "Pfad 47114",
    d: "M14.789,18.556v1.465a1.465,1.465,0,0,1-1.465,1.465H7.465A1.465,1.465,0,0,1,6,20.021V11.965A1.465,1.465,0,0,1,7.465,10.5H8.93",
    transform: "translate(-6 -6.838)",
    fill: "none",
    stroke: "#44554c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.f73c2c679041331bfd917e0681f87521.svg";
export { ForwardRef as ReactComponent };